module.exports = __webpack_public_path__ + "img/pamm_sec2_1.f0539888.png";